import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/main.scss'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.config.productionTip = false
import WOW from 'wow.js'
import 'wow.js/css/libs/animate.css'
Vue.use(VueAxios, axios)

const wow = new WOW()
wow.init()

import ElementUI from 'element-ui';
import '@/styles/element-variables.scss'
Vue.use(ElementUI);

import { getSystemStatusApi } from './api';

const app = new Vue({
  router,
  store,
  render: h => h(App),
  data() {
    return {
      showSystemStop: false,
      systemInfo: ''
    }
  },
  methods: {
    checkSystemStatus() {
      getSystemStatusApi().then(response => {
        console.log('系统状态检查响应:', response);
        if (response && response.code === 200) {
          const { system_status, system_info } = response.data;
          console.log('system_status:', system_status);
          console.log('system_info:', system_info);
          if (system_status === 0) {
            this.systemInfo = system_info;
            this.showSystemStop = true;
            console.log('显示系统停用弹窗，systemInfo:', this.systemInfo);
          } else {
            console.log('系统状态正常，不显示弹窗');
          }
        }
      }).catch(error => {
        console.error('检查系统状态失败:', error);
      });
    }
  }
}).$mount('#app')

// 将store挂载到window对象上，方便响应拦截器访问
window.store = store

// 应用启动时检查token，如果存在则获取最新用户信息
if (localStorage.getItem('token')) {
  app.$store.dispatch('getUserInfo')
}

// 应用启动时检查系统状态
app.checkSystemStatus();

// 应用启动时获取网站名称并设置标题
axios.get('/api/param/get', {
  params: {
    code: 'site_name'
  }
}).then(response => {
  if (response.data && response.data.code === 200 && response.data.data) {
    document.title = response.data.data
  }
}).catch(error => {
  console.error('获取网站名称失败:', error)
})

// 路由导航守卫（在Vue实例创建后添加，以便使用Element UI的Message组件）
router.beforeEach((to, from, next) => {
  // 检查系统状态
  getSystemStatusApi().then(response => {
    console.log('路由守卫 - 系统状态检查响应:', response);
    if (response && response.code === 200) {
      const { system_status, system_info } = response.data;
      console.log('路由守卫 - system_status:', system_status);
      console.log('路由守卫 - system_info:', system_info);
      if (system_status === 0) {
        app.systemInfo = system_info;
        app.showSystemStop = true;
        console.log('路由守卫 - 显示系统停用弹窗，showSystemStop:', app.showSystemStop);
      }
    }
  }).catch(error => {
    console.error('路由守卫 - 检查系统状态失败:', error);
  });

  // 检查路由是否需要身份认证
  if (to.meta.requiresAuth) {
    // 检查是否已登录（通过localStorage中的token判断）
    const token = localStorage.getItem('token')
    if (token) {
      // 已登录，继续访问
      next()
    } else {
      // 未登录，提示用户需要登录
      Vue.prototype.$message.error('请先登录')
      // 重定向到首页
      next('/')
    }
  } else {
    // 不需要身份认证，继续访问
    next()
  }
})
